
            const data = {"name":"ic_add_more","data":{"width":"27","height":"27","viewBox":"0 0 27 27","data":"<circle pid=\"0\" cx=\"13.5\" cy=\"13.5\" r=\"13.5\" _fill=\"#090\"/><path pid=\"1\" d=\"M13.477 16.403h.955v-2.335h2.335v-.954h-2.335v-2.336h-.955v2.336h-2.335v.954h2.335v2.335z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#090"},{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                module.exports = data
                